

import { lazy } from "react";
import { Navigate } from "react-router-dom";

/****Layouts*****/
const FullLayout = lazy(() => import("../layouts/FullLayout/FullLayout.js"));
/****End Layouts*****/

/*****Pages******/
const Dashboard1 = lazy(() => import("../screen/dashboard/index.js"));
const Login = lazy(() => import('../screen/login/Login'));
const Project = lazy(() => import("../screen/Project.js"));
const Withdraw = lazy(() => import("../screen/withdraw/Withdraw.js"));
const Users = lazy(() => import("../screen/user/index.js"));
const UserDetail = lazy(() => import("../screen/user/detail.js"));
const MultiSigWallet = lazy(() => import("../screen/multisig"));
const Ad = lazy(() => import("../screen/AdList"));
const AdForm = lazy(() => import("../screen/AdForm.js"));
const TaskDetail = lazy(() => import("../screen/task/detail"));
const Tasks = lazy(() => import("../screen/task/index.js"));
const PoolBilling = lazy(() => import("../screen/billing"));
const ProjectForm = lazy(()=>import ("../screen/ProjectForm.js"));
const Deposit = lazy(()=>import("../screen/deposit/deposit.js"));
const NoticeList = lazy(()=>import("../screen/notice/NoticeList.js"));
const Notice = lazy(()=>import("../screen/notice/Notice.js"))
const NFT = lazy(()=>import('../screen/nft'));
const Fleet = lazy(()=>import('../screen/fleet'));
const PoolRequest = lazy(()=>import('../screen/billing/request.js'))
const Account = lazy(()=>import('../screen/account/index.js'));
const AuctionManage = lazy(()=>import('../screen/auction/index.js'));
const Price =lazy(()=>import('../screen/Price.js'));
const Financial = lazy(()=>import('../screen/user/financial.js'));
const RoundsManager = lazy(()=>import('../screen/ido/rounds.js'));
const L3SubscriptionManager = lazy(()=>import('../screen/ido/l3subround.js'));
const L3FlashBuyManager = lazy(()=>import('../screen/ido/l3flashround.js'));
const L3DiscountManager = lazy(()=>import('../screen/ido/l3discountround.js'));
// // form layouts
// const FormLayouts = lazy(() => import("../views/FormLayouts/FormLayouts.js"));

/*****Routes******/

const ThemeRoutes = [
    {
        path: "/",
        element: <FullLayout />,
        children: [
            // { path: "/login", element: <Login /> },
            { path: "/", element: <Navigate to="dashboards/dashboard1" /> },
            { path: "dashboards/dashboard1", exact: true, element: <Dashboard1 /> },
            { path: "/projects", element: <Project /> },
            { path: "/projects/add", element: <ProjectForm action="add" /> },
            { path: "/projects/:id", element: <ProjectForm action="edit" /> },
            { path: "/withdraws", element: <Withdraw /> },
            { path: "/users", element: <Users /> },
            { path: "/users/:id", element: <UserDetail /> },
            { path: "/ads", element: <Ad /> },
            { path: "/ads/add", element: <AdForm action='add' /> },
            { path: "/ads/:id", element: <AdForm action='edit' /> },
            { path: "/tasks", element: <Tasks /> },
            { path: "/tasks/:id", element: <TaskDetail /> },
            { path: "/billing", element: <PoolBilling /> },
            { path: "/fleet/requests", element: <PoolRequest /> },
            { path:"/deposits", element: <Deposit/>},
            { path:'/price',element:<Price/>},
            //   { path: "/form-elements/checkbox", element: <ExCheckbox /> },
            //   { path: "/form-elements/radio", element: <ExRadio /> },
            //   { path: "/form-elements/slider", element: <ExSlider /> },
            { path: "/multisig", element: <MultiSigWallet /> },
            {path:"/notices", element:<NoticeList/>},
            {path:"/notices/add", element:<Notice/>},
            {path:"/notices/:id", element:<Notice mode="edit"/>},
            {path:'/nft',element:<NFT/>},
            {path:'/fleet',element:<Fleet/>},
            {path:'/account',element:<Account/>},
            {path:'/ido/auction/:id',element:<AuctionManage/>},
            {path:'/ido/project/:id/rounds',element:<RoundsManager/>},
            {path:'/l3subround/:id',element:<L3SubscriptionManager/>},
            {path:'/l3flashround/:id',element:<L3FlashBuyManager/>},
            {path:'/l3discountround/:id',element:<L3DiscountManager/>},
            {path:'/users/financial/:id',element:<Financial/>}

        ],
    },
    {
        path:'/login',
        element:<Login/>
    }
];

export default ThemeRoutes;
